<template>
  <div class="sc-tabs-container"
       v-dragscroll.x="true"
       @dragscrollmove="handleDrag"
       @dragscrollstart="handleDragStart"
       @dragscrollend="handleDragEnd"
       ref="scrollingTabsContainer">
    <ul role="menubar" class="sc-scrolling-tabs" ref="scrollingTabs">
      <li class="single-tab"
          v-for="(tab, index) in tabList"
          :key="'scrollTab'+index"
          ref="singleScrollingTab">
        <a href="#"
           :class="{active: tab === selectedTab}"
           @click.prevent="selectTab(tab, index)">{{ tab }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'
import debounce from '@/utils/debounce'

const DEFAULT_SCROLL_VALUE = 50
export default {
  name: 'scrolling-tab-header',
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    firstSelectedTab: [String, Number],
    preventFirstTabSelect: Boolean
  },
  directives: {
    dragscroll: dragscroll
  },
  data () {
    return {
      selectedTab: '',
      totalItemsWidth: 0
    }
  },
  methods: {
    selectTab (tabName, index) {
      this.selectedTab = tabName
      this.checkTabPosition(this.$refs.singleScrollingTab[index])
    },
    handleDrag (e) {
      const elem = e.target ? e.target : e
      debounce(() => {
        this.tabsOverflowedLeft = elem.scrollLeft > 0
        this.tabsOverflowedRight = elem.scrollLeft + this.$refs.scrollingTabsContainer.getBoundingClientRect().width < this.totalItemsWidth
      }, 10)
    },
    handleDragStart () {
      this.preventSelect = true
    },
    handleDragEnd () {
      setTimeout(() => {
        this.preventSelect = false
      }, 50)
    },
    autoSelectTab () {
      const firstTab = this.$props.firstSelectedTab
      if (firstTab !== undefined) {
        // if string, it's tab name
        if (typeof firstTab === 'string') {
          this.selectedTab = firstTab
          // if it's number, then it's tab index
        } else if (typeof firstTab === 'number') {
          this.selectedTab = this.$props.tabList[firstTab]
        } else {
          // all other cases, select first tab
          this.selectedTab = this.$props.tabList.length ? this.$props.tabList[0] : ''
        }
      } else {
        this.selectedTab = this.$props.tabList.length ? this.$props.tabList[0] : ''
      }
    },
    calculateScrollingContainer () {
      this.totalItemsWidth = this.getItemsTotalWidth(this.$refs.singleScrollingTab)
      if (this.$refs.scrollingTabsContainer.getBoundingClientRect().width < this.totalItemsWidth) {
        this.tabsOverflowedRight = true
      } else {
        this.tabsOverflowedRight = false
        this.tabsOverflowedLeft = false
      }
    },
    getItemsTotalWidth (itemList) {
      let totalWidth = 0
      itemList.forEach(item => {
        totalWidth += item.getBoundingClientRect().width
      })

      return totalWidth
    },
    checkTabPosition (tabElement) {
      const container = this.$refs.scrollingTabsContainer
      const tabPosLeft = tabElement.getBoundingClientRect().left
      const tabWidth = tabElement.getBoundingClientRect().width
      const containerPosLeft = container.getBoundingClientRect().left
      const containerWidth = container.getBoundingClientRect().width
      const buffer = DEFAULT_SCROLL_VALUE
      if (tabPosLeft < containerPosLeft + buffer) {
        this.scrollList(tabPosLeft - containerPosLeft - buffer)
      }
      if (containerPosLeft + containerWidth < tabPosLeft + tabWidth + buffer) {
        this.scrollList(tabWidth + buffer)
      }
    },
    scrollList (scrollValue) {
      this.$refs.scrollingTabsContainer.scroll({
        left: this.$refs.scrollingTabsContainer.scrollLeft + scrollValue,
        top: 0,
        behavior: 'smooth'
      })
      setTimeout(() => {
        this.handleDrag(this.$refs.scrollingTabsContainer)
      }, 300)
    }
  },
  watch: {
    selectedTab: {
      handler (newVal) {
        if (newVal) {
          this.$emit('tab-change', newVal)
        }
      },
      immediate: true
    }
  },
  mounted () {
    if (!this.$props.preventFirstTabSelect) {
      this.autoSelectTab()
    }
    this.$nextTick(() => {
      this.calculateScrollingContainer()
    })
  }
}
</script>

<style scoped lang="scss">
.sc-tabs-container {
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  .sc-scrolling-tabs {
    display: flex;

    li.single-tab {
      margin-right: 2.5rem;

      @media (map_get($breakpoints, sm)) {
        margin-right: 5rem;
      }

      a {
        display: block;
        padding: 1.6rem 0;
        color: $white;
        text-transform: uppercase;
        text-decoration: none;
        font-size: 1.4rem;
        font-weight: normal;
        opacity: 0.5;
        white-space: nowrap;
        transition: box-shadow 0.2s, opacity 0.2s;
        will-change: box-shadow, opacity;

        @media (map_get($breakpoints, sm)) {
          font-size: 1.6rem;
        }

        &.active {
          box-shadow: inset 0 -2px 0 $white;
          opacity: 1;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
